import { useContext, useEffect, useState } from "react";
import { SIDER_TABS } from "../../../utils/Constants";
import AppContext from "../../../context/AppContext";
import { AppStrings } from "../../../utils/constants/AppStrings";
import WelcomeBonusConfig from "../WelcomeBonusConfig/WelcomeBonusConfig";
import ReferralBonusConfig from "../ReferralBonusConfig/ReferralBonusConfig";
import { usePageTitle } from "../../CommonComponents/Layout/PageTitleContext";
import "../stylesPromotions.css";

const BONUS_TABS = {
  WELCOME_BONUS: "welcome-bonus",
  REFERRAL_BONUS: "referral-bonus",
};

const BonusConfigs = () => {
  const { setActiveSidebarTab } = useContext(AppContext);
  const [activeTab, setActiveTab] = useState(BONUS_TABS.WELCOME_BONUS);
  usePageTitle(AppStrings.BONUS_CONTROLS);

  useEffect(() => {
    setActiveSidebarTab(SIDER_TABS.PROMOTIONS, "BONUS_CONTROLS");
  }, [setActiveSidebarTab]);

  return (
    <>
      <div className="promotions-container">
        <div className="kpis-tabs">
          <button
            className={activeTab === BONUS_TABS.WELCOME_BONUS ? "active" : ""}
            onClick={() => setActiveTab(BONUS_TABS.WELCOME_BONUS)}
          >
            {AppStrings.WELCOME_BONUS}
          </button>
          <button
            className={activeTab === BONUS_TABS.REFERRAL_BONUS ? "active" : ""}
            onClick={() => setActiveTab(BONUS_TABS.REFERRAL_BONUS)}
          >
            {AppStrings.REFERRAL_BONUS}
          </button>
        </div>
        <div className="promotions-content">
          {activeTab === BONUS_TABS.WELCOME_BONUS && <WelcomeBonusConfig />}
          {activeTab === BONUS_TABS.REFERRAL_BONUS && <ReferralBonusConfig />}
        </div>
      </div>
    </>
  );
};

export default BonusConfigs;
